import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {Observable} from 'rxjs';

import {Task} from '../../../../shared/workflow/workflow-v2.interface';

@Component({
  selector: 'gp-onboarding-fill-form-task',
  templateUrl: './onboarding-fill-form-task.component.html',
  styleUrls: ['./onboarding-fill-form-task.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingFillFormTaskComponent {

  @Input() task: Task;
  @Input() trigger$: Observable<number>;

  public readonly onboardingUrl = `${window.location.origin}/apps/onboarding/#/onboarding/file`;

  public getVariableValue(task: Task, name: string): any {
    return task?.variables?.find(variable => variable.name === name)?.value ?? null;
  }

  public isCorrectionRequested(task: Task): boolean {
    const correctForm = this.getVariableValue(task, 'correctForm');
    return correctForm === true || correctForm === 'true';
  }

  public getValidatorComment(task: Task): string {
    return this.getVariableValue(task, 'validatorComment') || '';
  }
}

